export default function parseErrorMessage(errorMessage: string): string {
  if (errorMessage.includes("simulation failed")) {
    return "Transaction simulation failed";
  }

  return errorMessage;
}
